import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";

const linkClass = ({ isActive }) =>
  `font-mono-tech text-xs tracking-[0.2em] uppercase px-3 py-2 border transition-colors duration-150 ${
    isActive
      ? "text-white border-white"
      : "text-white/70 border-transparent hover:text-white"
  }`;

const mobileLinkClass = ({ isActive }) =>
  `font-mono-tech text-xs tracking-[0.2em] uppercase px-3 py-2 border w-fit transition-colors duration-150 ${
    isActive
      ? "text-white border-white"
      : "text-white border-transparent"
  }`;

export const SiteNav = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-30 bg-cyber-black/80 backdrop-blur-md border-b border-cyber-line" data-testid="site-nav">
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-5 sm:px-8 py-4">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <span className="font-mono-tech text-cyber-yellow text-xs tracking-[0.3em]">FINTECHOMNI</span>
          <span className="w-2 h-2 bg-cyber-green animate-blink" />
        </Link>
        <nav className="hidden md:flex items-center gap-2">
          <NavLink to="/" end className={linkClass} data-testid="nav-home">Home</NavLink>
          <NavLink to="/events/fintechomni-las-vegas-2027" className={linkClass} data-testid="nav-event">Upcoming Event</NavLink>
          <NavLink to="/news" className={linkClass} data-testid="nav-news">News</NavLink>
          <NavLink to="/about" className={linkClass} data-testid="nav-about">About</NavLink>
          <NavLink to="/contact" className={linkClass} data-testid="nav-contact">Contact</NavLink>
        </nav>
        <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-cyber-line bg-cyber-black px-5 py-5 flex flex-col gap-2" data-testid="mobile-menu">
          <NavLink to="/" end onClick={() => setOpen(false)} className={mobileLinkClass}>Home</NavLink>
          <NavLink to="/events/fintechomni-las-vegas-2027" onClick={() => setOpen(false)} className={mobileLinkClass}>Upcoming Event</NavLink>
          <NavLink to="/news" onClick={() => setOpen(false)} className={mobileLinkClass}>News</NavLink>
          <NavLink to="/about" onClick={() => setOpen(false)} className={mobileLinkClass}>About</NavLink>
          <NavLink to="/contact" onClick={() => setOpen(false)} className={mobileLinkClass}>Contact</NavLink>
        </div>
      )}
    </header>
  );
};

export default SiteNav;
